/* eslint-disable react-refresh/only-export-components */
import { useEffect } from "react";
import { useGetIdentity } from "ra-core";
import {
  appearanceAccount,
  appearanceKey,
  usePersistentAppearance,
} from "@/components/admin/appearance-preferences";
import { Switch } from "@/components/ui/switch";

const choices = ["on", "off"] as const;
export const useMotionPreference = () => {
  const { identity } = useGetIdentity();
  return usePersistentAppearance(
    appearanceKey(appearanceAccount(identity?.id), "motion"),
    "on",
    choices,
  );
};

export const useApplyMotionPreference = () => {
  const [motion] = useMotionPreference();
  useEffect(() => {
    document.documentElement.dataset.motion = motion;
    return () => {
      delete document.documentElement.dataset.motion;
    };
  }, [motion]);
};

export const MotionPreference = () => {
  const [motion, setMotion] = useMotionPreference();
  return (
    <div className="flex items-center justify-between gap-4 rounded-2xl border p-4">
      <div className="space-y-1">
        <label htmlFor="interface-motion" className="text-sm font-medium">
          Анимации интерфейса
        </label>
        <p id="motion-description" className="text-xs text-muted-foreground">
          Переходы, раскрытие панелей, появление карточек и отклик кнопок. Выбор
          сохраняется для вашего аккаунта в этом браузере; учитывает настройку
          уменьшения движения на устройстве.
        </p>
      </div>
      <Switch
        id="interface-motion"
        aria-describedby="motion-description"
        checked={motion === "on"}
        onCheckedChange={(checked) => setMotion(checked ? "on" : "off")}
      />
    </div>
  );
};
